import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, of, Subscription, switchMap, take } from 'rxjs';
import { DocumentoComprovacaoService } from 'src/app/modules/services/documento-comprovacao/documento-comprovacao.service';
import { PageSizeService } from 'src/app/modules/services/page-size/page-size.service';

import { MatSnackBar } from '@angular/material/snack-bar';

import { MatDialog } from '@angular/material/dialog';
import { EntitiesService } from 'src/app/modules/services/entities/entities.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';

import { FormatUtilsService } from 'src/app/modules/services/format-utils/format-utils.service';
import { AfericaoServicoInicialService } from 'src/app/modules/shared/afericao-servico-Inicial/afericao-servico-inicial.service';
import { AlertComponent } from 'src/app/modules/components/alert/alert.component';
import { LoadingService } from 'src/app/modules/components/loading/loading.service';
import { ModalComponent } from 'src/app/modules/components/modal/modal.component';
import { DocumentosService } from 'src/app/modules/services/documentos/documentos.service';
import { AfericaoRelatorioService } from 'src/app/modules/services/afericao-relatorio/afericao-relatorio.service';
import { AfericaoOperacionalService } from 'src/app/modules/services/afericao-operacional/afericao-operacional.service';

interface UploadedFile {
  file: File;
  url: SafeUrl;
  isImage: boolean;
}

@Component({
  selector: 'app-view-documents-comprovacao',
  templateUrl: './view-documents-comprovacao.component.html',
  styleUrls: ['./view-documents-comprovacao.component.scss']
})
export class ViewDocumentsComprovacaoComponent {
// 1. Controle de formulário e interação
comentario: string = '';
comentarios: string = '';
searchControl = new FormControl('');
selectedOption: any;
filteredOptions: any[] = [];

// 2. Dados de documentos, imagens e arquivos
files: UploadedFile[] = [];
filesAdded: {
  nomeArquivo: string;
  tipoMime: string;
  categoria: string;
  subCategoria: string;
  objetoOriginal: File;
}[] = [];
imagens: string[] = [];
arquivos: string[] = [];
imageIndex: number = 0;
imagesForView: any[] = [];
documentsForView: any[] = [];
documentoComprovacao: any;
extensoesImagem = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.tiff'];

// 3. Dados de exibição (tabela, paginação, ordenação)
dataSource = new MatTableDataSource<any>([]);
displayedColumns: string[] = [];
columnConfig = [
  { columnDef: 'assinante', header: 'Assinante', property: 'usuario.nome' },
  { columnDef: 'dataAssinatura', header: 'Data e hora de assinatura', property: 'dataAssinatura', customTd: true },
];
sortState = {
  sortProperty: 'usuario.nome',
  sortDirection: 'asc'
};
pageIndex: number = 0;
pageSize: number = 10;
totalPages: number = 1;
totalElements: number = 0;

// 4. Metadados / Identificadores
protocolo: string = '';
status: 'pending' | 'approved' | 'rejected' = 'pending';
idDocumentoComprovacao: any;
idAfericao: any;
transicaoId!: string;
idStatusAtual!: string;
entitie: any;
afericao: any;

// 5. Outros controles e configurações
buttonExclusaoDisabled: boolean = false;
screenWidth: number = window.innerWidth;
subsctiptions: Subscription[] = [];
firstLine: any[] = [];
secondtLine: any[] = [];
from: string = '';
// 6. Privadas (controle de página)
private imagePageIndex = 0;
private readonly imagesPerPage = 4; // 4 por linha × 2 linhas
private documentPageIndex = 0;
private readonly documentsPerPage = 4;

  constructor(
    private pageSizeService: PageSizeService,
    private afericaoServicoInicialService: AfericaoServicoInicialService,
    public toastService: ToastService,
    private route: ActivatedRoute,
    private router: Router,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private loadingService: LoadingService,
    private documentServices: DocumentosService,
    private afericaoRelatorioService: AfericaoRelatorioService,
    private afericaoOperacionalService: AfericaoOperacionalService
  ) { }

ngOnInit(): void {
  this.route.paramMap.subscribe((params: any) => {
    this.idDocumentoComprovacao = params.get('idDocumentoComprovacao');
    this.idAfericao = params.get('idAfericao');
    this.from = params.get('from');
    this.getDocumentosComprovacao(this.idAfericao, this.idDocumentoComprovacao);
  });

  this.displayedColumns = this.columnConfig.map(col => col.columnDef);
}

getDocumentosComprovacao(idAfericao: string, idDocumentoComprovacao: string): void {
  this.loadingService.showLoading();

  if(this.from == 'inicial'){
 this.subsctiptions.push(
    this.afericaoServicoInicialService
      .getDocumentosComprovacao(idAfericao, idDocumentoComprovacao)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: (response: any) => {
          this.documentoComprovacao = response;
          this.dataSource.data = response.usuariosAssinantes;

          const obterExtensao = (nomeArquivo: string): string =>
            nomeArquivo.slice(nomeArquivo.lastIndexOf('.')).toLowerCase();

          // Separa arquivos
          this.imagens = response.arquivos.filter((arquivo: any) =>
            this.extensoesImagem.includes(obterExtensao(arquivo.nomeArquivo))
          );
          this.arquivos = response.arquivos.filter((arquivo: any) =>
            !this.extensoesImagem.includes(obterExtensao(arquivo.nomeArquivo))
          );

          this.organizeImages();
          this.organizeDocuments();
        },
        error: (erro: any) => {
          const msg = erro.status !== 500 && erro.status
            ? erro.error.message
            : undefined;
          this.toastService.showError(msg);
        },
      })
  );
  }else if(this.from == 'operacional'){
    this.subsctiptions.push(
    this.afericaoOperacionalService
      .getDocumentosComprovacao(idAfericao, idDocumentoComprovacao)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: (response: any) => {
          this.documentoComprovacao = response;
          this.dataSource.data = response.usuariosAssinantes;

          const obterExtensao = (nomeArquivo: string): string =>
            nomeArquivo.slice(nomeArquivo.lastIndexOf('.')).toLowerCase();

          // Separa arquivos
          this.imagens = response.arquivos.filter((arquivo: any) =>
            this.extensoesImagem.includes(obterExtensao(arquivo.nomeArquivo))
          );
          this.arquivos = response.arquivos.filter((arquivo: any) =>
            !this.extensoesImagem.includes(obterExtensao(arquivo.nomeArquivo))
          );

          this.organizeImages();
          this.organizeDocuments();
        },
        error: (erro: any) => {
          const msg = erro.status !== 500 && erro.status
            ? erro.error.message
            : undefined;
          this.toastService.showError(msg);
        },
      })
  );
  }else{
    this.subsctiptions.push(
    this.afericaoRelatorioService
      .getDocumentosComprovacao(idAfericao, idDocumentoComprovacao)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: (response: any) => {
          this.documentoComprovacao = response;
          this.dataSource.data = response.usuariosAssinantes;

          const obterExtensao = (nomeArquivo: string): string =>
            nomeArquivo.slice(nomeArquivo.lastIndexOf('.')).toLowerCase();

          // Separa arquivos
          this.imagens = response.arquivos.filter((arquivo: any) =>
            this.extensoesImagem.includes(obterExtensao(arquivo.nomeArquivo))
          );
          this.arquivos = response.arquivos.filter((arquivo: any) =>
            !this.extensoesImagem.includes(obterExtensao(arquivo.nomeArquivo))
          );

          this.organizeImages();
          this.organizeDocuments();
        },
        error: (erro: any) => {
          const msg = erro.status !== 500 && erro.status
            ? erro.error.message
            : undefined;
          this.toastService.showError(msg);
        },
      })
  );
  }
 
}

downloadFile(doc: any): void {
  // this.documentServices.convertBlobAndDownload(doc);
   window.open(doc, '_blank');
}

reiniciar(): void {
  this.imagens = [];
  this.arquivos = [];
}

// ---------- Organização e Paginação ----------

private organizeDocuments(): void {
  this.updateDocumentView();
}

private organizeImages(): void {
  this.updateImageView();
}

private updateImageView(): void {
  const start = this.imagePageIndex * this.imagesPerPage;
  this.imagesForView = this.imagens.slice(start, start + this.imagesPerPage);
}

prevImages(): void {
  if (this.imagePageIndex > 0) {
    this.imagePageIndex--;
    this.updateImageView();
  }
}

nextImages(): void {
  const maxPages = Math.ceil(this.imagens.length / this.imagesPerPage);
  if (this.imagePageIndex < maxPages - 1) {
    this.imagePageIndex++;
    this.updateImageView();
  }
}

private updateDocumentView(): void {
  const start = this.documentPageIndex * this.documentsPerPage;
  this.documentsForView = this.arquivos.slice(start, start + this.documentsPerPage);
}

prevDocuments(): void {
  if (this.documentPageIndex > 0) {
    this.documentPageIndex--;
    this.updateDocumentView();
  }
}

nextDocuments(): void {
  const maxPages = Math.ceil(this.arquivos.length / this.documentsPerPage);
  if (this.documentPageIndex < maxPages - 1) {
    this.documentPageIndex++;
    this.updateDocumentView();
  }
}

// ---------- Getters Auxiliares ----------

get imageFiles(): UploadedFile[] {
  return this.files.filter(f => f.isImage);
}

get otherFiles(): UploadedFile[] {
  return this.files.filter(f => !f.isImage);
}

// ---------- Ordenação ----------

onSortChange(sortProperty: any): void {
  if (this.sortState.sortProperty === sortProperty) {
    this.sortState.sortDirection =
      this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    this.sortState.sortProperty = sortProperty;
    this.sortState.sortDirection = 'asc';
  }

  this.getData();
}

getData(pageIndex: number = 0): void {
  // (Ainda não implementado)
}
  pageChangeEvent(event: PageEvent) {
    if (this.pageSize !== event.pageSize) {
      this.pageSize = event.pageSize;
      this.pageSizeService.setPageSize(event.pageSize);
      return this.getData(0);
    }

    if (this.pageIndex !== event.pageIndex) {
      return this.getData(event.pageIndex);
    }
  }
  onOptionSelected(event: any) {
    const selectedOption = event.option.value;
    this.selectedOption = selectedOption;
    this.searchControl.setValue(selectedOption.user.nome, { emitEvent: false }); // Evita disparar valueChanges
    this.filteredOptions = [];
  }
  addUser() {

    if (!this.selectedOption) {
      this.openSnackBar('Selecione o usuário.', 'warning');
      return; // Impede a adição
    }
    const novoElemento = this.selectedOption;

    const dados = this.dataSource.data;

    // Verifica se já existe um elemento com o mesmo ID
    const existe = dados.some(item => item.user.id === novoElemento.user.id);

    if (existe) {
      this.openSnackBar('Usuário já adicionado anteriormente.', 'warning');
      return; // Impede a adição
    }

    // Adiciona e atualiza o dataSource
    this.dataSource.data = [...dados, novoElemento];
  }
  openDeleteDialog(id: any): void {
    const modalTitle: string = 'Excluir';
    const modalContent: string =
      'Você tem certeza que deseja excluir este Usuário?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onDeleteModalConfirm.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: id,
      },
    });
  }
  onDeleteModalConfirm(id: any): void {
    const dados = this.dataSource.data;

    // Verifica se o elemento existe
    const existe = dados.some(item => item.id === id);

    if (!existe) {
      this.openSnackBar('Usuário não encontrado.', 'warning');
      return; // Impede a exclusão
    }

    // Remove o elemento e atualiza o dataSource
    this.dataSource.data = dados.filter(item => item.id !== id);
    this.openSnackBar('Usuário deletado com sucesso.', 'sucess');
  }
  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
  cancel() {
    if(this.from == 'inicial'){
      this.router.navigate([`detail-afericao-inicial/${this.idAfericao}`]);
    }else if(this.from == 'operacional'){
        this.router.navigate([`detail-afericao-operacional/${this.idAfericao}`]);
      }
    else{
       this.router.navigate([`detail-afericao-relatorios/${this.idAfericao}`]);
    }
    
  }
}
